<ng-container *ngIf="svgIcon; else ligature">
  <span class="app-icon__svg" [innerHTML]="svg"></span>
</ng-container>
<ng-template #ligature><ng-content></ng-content></ng-template>
